import React from 'react'
import './Dropdown.css'
import Carot from './carot.svg'
import { Link } from 'react-router-dom'

const linkStyle = {
  margin: "0rem 24px 0rem 24px",
  textDecoration: "none",
  color: 'white',
  fontSize: "12px",
};

export default function Dropdown() {
  return (
    <div>
      <div className='topics'>
      <Link to = "/css" style={linkStyle}><h1>CSS</h1></Link>
            <div class="dropdown">
              <button class="dropbtn">Lessons 
              <img src= {Carot} />
              </button>
              <div class="dropdown-content">
                  <h4>Module 1:Get Started</h4>  
                  <a href="#">1. What is CSS?</a>
                  <a href="#">2. CSS Demo</a>
                  <a href="#">3. Syntax</a>
                  <a href="#">4. Add CSS to web page : Inline</a>
                  <a href="#">5. Add CSS to web page : Internal</a>
                  <a href="#">6. Add CSS to web page : External</a>

                  <h4>Module 2:Selectors & Styling</h4>  
                  <a href="#">1. Type selector</a>
                  <a href="#">2. ID selector</a>
                  <a href="#">3. Class selector</a>
                  <a href="#">4. Grouping selectors</a>
                  <a href="#">5. Attribute selector</a>
                  <a href="#">6. Color</a>
                  <a href="#">7. Letter Spacing & Line Height</a>
                  <a href="#">8. text-decoration</a>
                  <a href="#">9. font-family</a>
                  <a href="#">10. font stack</a>
                  <a href="#">11. font-size</a>
                  <a href="#">12. font-weight</a>
                  <a href="#">13. Google Fonts</a>
                  <a href="#">14. Comments</a>
                  <a href="#">15. Background color</a>
                  <a href="#">16. Border color</a>
                  <a href="#">17. Color value</a>

                  <h4>Module 3: Diving Deeper</h4>  
                  <a href="#">1. Default Browser Styles</a>
                  <a href="#">2. Inheritance</a>
                  <a href="#">3. Specificity</a>
                  <a href="#">4. Calculatng Specificity</a>
                  <a href="#">5. Selecting nested elements</a>
                  <a href="#">6. Background Image</a>
                  <a href="#">7. Linear Gradients</a>

                  <h4>Module 4: Building Layouts</h4>  
                  <a href="#">1. Block elements</a>
                  <a href="#">2. Inline elements</a>
                  <a href="#">3. Box Model</a>
                  <a href="#">4. Padding</a>
                  <a href="#">5. Border</a>
                  <a href="#">6. Margin</a>
                  <a href="#">7. Position : static</a>
                  <a href="#">8. Position : relative</a>
                  <a href="#">9. Position : fixed</a>
                  <a href="#">10. Position : absolute</a>
                  
              </div>
            </div> 
      </div>
    </div>
  )
}
